export default "__VITE_ASSET__GMKIqXLD__"